import type { ThemeOptions } from "@mui/material";

export const ENERMATCH_COLORS: ThemeOptions = {
  palette: {
    primary: { main: "#2E8267", dark: "#0C4433" },
    secondary: { main: "#595959", light: "#CACACA" },
    success: { main: "#2E7D32", light: "#D8F8D9" },
    warning: { main: "#ED6C02", light: "#F3E7CA" },
    error: { main: "#D32F2F", light: "#F8E6E3" },
    text: {
      primary: "#595959",
      secondary: "#fff",
    },
    backgrounds: {
      primary: "#E3E3E3",
      secondary: "#FFF",
      pageGradient:
        "linear-gradient(180deg, rgba(239, 200, 110, 0.20) 0%, rgba(153, 201, 129, 0.20) 47%, rgba(76, 151, 145, 0.20) 74%, rgba(70, 147, 137, 0.20) 81%, rgba(55, 137, 118, 0.20) 92%, rgba(42, 128, 101, 0.20) 100%), #fff",
      sectionGradient:
        "radial-gradient(50% 177.48% at 51.55% 48.5%, rgba(239, 200, 110, 0.2), rgba(224, 200, 113, 0.2), rgba(153, 201, 129, 0.2)), #FFF",
    },
    charts: {
      primary: "#E3BB5C",
      secondary: "#26A47C",
      primaryDark: "#F2BB4F",
      secondaryDark: "#0C4433",
      border: `0.703px solid #E3BB5C`,
    },
  },
  typography: {
    fontFamily: "Montserrat, sans-serif",
  },
  shadow: "2px 2px 5px rgba(0, 0, 0, 0.3)",
};
